export enum PluginTypes {
  Private = 'private',
  Shared = 'shared',
}
